import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import { db } from "../firebase";
import logo from "../images/logo.png";
import "../styles/userConsent.css";
import Consent from "./Consent";

export class Register extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      email: "",
      employeId: "",
      familyName: "",
      accessMyPicture: false,
      consent: false,
      error: "",
      message: null,
      consentBox: false,
      userExist: false,
      errorEmail: "",
      errorConsent: "",
      errorAccessPicture: "",
      letGo: false,
    };
  }

  // For email and employeeId
  handleTrimChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value.trim(),
    });
  };

  // For name and family name
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  // let appear consent box
  handleConsentBox = (e) => {
    this.setState({ consentBox: true });
  };

  handleAccessMyPicture = (e) => {
    this.setState({
      accessMyPicture: !this.state.accessMyPicture,
    });
  };

  // Accepting consent
  handleConsent = (e) => {
    this.setState({
      consent: !this.state.consent,
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    if (!this.state.consent) {
      this.setState({
        errorConsent:
          "Please provide your consent in order to proceed with the registration",
      });
    } else {
      this.setState({
        errorConsent: "",
      });
    }
    // Check SAP email
    const re = RegExp(/^[A-Za-z0-9._%+-]+@sap.com$/);
    if (!re.test(this.state.email)) {
      this.setState({ errorEmail: "Please use SAP email." });
    } else if (this.state.consent && this.state.email) {
      // SAP mail found
      const docname = String("" + this.state.email).toLowerCase();
      var doc = "";
      try {
        const ref = db.collection("users").doc(docname);
        doc = await ref.get();
      } catch (error) {
        this.setState({ error: "Check Your Internet Connection" });
      }

      if (!doc.exists) {
        // For new user save to app state
        const data = {
          name: this.state.name,
          email: this.state.email,
          employeId: this.state.employeId,
          familyName: this.state.familyName,
          accessMyPicture: this.state.accessMyPicture,
          consent: this.state.consent,
        };
        this.props.handleBasicRegistration(data);
        this.setState({ letGo: true });
      } else {
        const item = doc.data();
        // If registration completed

        console.log("false ya blank");
        const data = {
          name: this.state.name,
          email: item.email,
          employeId: this.state.employeId,
          familyName: this.state.familyName,
          accessMyPicture: this.state.accessMyPicture,
          consent: this.state.consent,
        };
        this.props.handleBasicRegistration(data);
        this.setState({ letGo: true });
      }
      // end check SAP EMAIL
    }
  };

  render() {
    const renderConsentBox = () => {
      if (this.state.consentBox) {
        return (
          <div
            style={{
              maxHeight: "220px",
              minHeight: "100px",
              overflow: "scroll",
              backgroundColor: "white",
              padding: "20px",
            }}
          >
            <div
              className="consent-content"
              style={{
                textAlign: "left",
                fontWeight: "normal",
                fontSize: "10px",
              }}
            >
              <div>
                <Consent name={this.state.name}></Consent>
              </div>

              <div
                className="checkbox consent-checkbox"
                style={{ padding: "0px 20px" }}
              >
                <input
                  type="checkbox"
                  id="checkbox2"
                  name="consent"
                  checked={!this.state.consent ? false : true}
                  onChange={this.handleConsent}
                />
                <label htmlFor="checkbox2">
                  <span>
                    I, the undersigned represent that I am signing this Release
                    voluntarily as an individual.
                  </span>
                </label>
              </div>
            </div>

            {/* <div className="col-12 d-flex">
              
            </div> */}
          </div>
        );
      } else {
        return <div></div>;
      }
    };
    return (
      <div className="cmn-bg">
        {this.state.letGo ? <Redirect to="/clickpicture" /> : null}

        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="text-center">
                <Link to="/">
                  <img src={logo} alt="logo" className="logo" />
                </Link>
                <form className="reg-form" onSubmit={this.handleSubmit}>
                  {/* Prints error and messages */}
                  {this.state.error ? (
                    <p style={{ color: "red" }}>{this.state.error}</p>
                  ) : null}
                  {this.state.errorAccessPicture ? (
                    <p style={{ color: "red" }}>
                      {this.state.errorAccessPicture}
                    </p>
                  ) : null}
                  {this.state.errorConsent ? (
                    <p style={{ color: "red" }}>{this.state.errorConsent}</p>
                  ) : null}
                  {this.state.message ? (
                    <p style={{ color: "white" }}>{this.state.message}</p>
                  ) : null}
                  <div className="row align-items-center my-3">
                    <label className="col-sm-3 text-white">Name:</label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="textbox"
                        name="name"
                        onChange={this.handleChange}
                        value={this.state.name}
                        required
                      />
                    </div>
                  </div>
                  <div className="email-error row  my-3">
                    <div className="col-md-9 col-md-offset-3 col-sm-12">
                      {this.state.errorEmail ? (
                        <span style={{ color: "red" }}>
                          {this.state.errorEmail}
                        </span>
                      ) : null}
                    </div>
                  </div>
                  <div className="row align-items-center my-3">
                    <label className="col-sm-3 text-white">Email ID:</label>
                    <div className="col-sm-9 ">
                      <input
                        type="email"
                        className="textbox"
                        name="email"
                        onChange={this.handleTrimChange}
                        value={this.state.email}
                        required
                      />
                    </div>
                  </div>
                  <div className="row align-items-center my-3">
                    <label className="col-sm-3  text-white">Employee ID:</label>
                    <div className="col-sm-9 ">
                      <input
                        type="text"
                        className="textbox"
                        name="employeId"
                        onChange={this.handleTrimChange}
                        value={this.state.employeId}
                        required
                      />
                    </div>
                  </div>
                  <div className="row align-items-center my-3">
                    <label className="col-sm-3  text-white">Family Name:</label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="textbox"
                        name="familyName"
                        onChange={this.handleChange}
                        value={this.state.familyName}
                        required
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-3 ">&nbsp;</div>
                    <div className="col-sm-9 ">
                      <div className="row">
                        <div className="col-12 d-flex">
                          <div className="checkbox">
                            <input
                              type="checkbox"
                              id="checkbox"
                              name="accessMyPicture"
                              checked={
                                this.state.accessMyPicture ? true : false
                              }
                              onChange={this.handleAccessMyPicture}
                            />
                            <label htmlFor="checkbox">
                              <span>
                                I agree to SAP India accessing my picture and
                                using the same for activities related to Annual
                                Day 2020
                              </span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <p
                        className="text-center text-blue"
                        style={{ cursor: "pointer" }}
                        onClick={this.handleConsentBox}
                      >
                        <span
                          style={{
                            color: "yellow",
                            textDecoration: "underline",
                          }}
                        >
                          Click here
                        </span>{" "}
                        to view SAP release form for consent
                      </p>
                      {renderConsentBox()}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 my-2">
                      {!this.state.userExist ? (
                        <input
                          type="submit"
                          className="register-btn text-uppercase"
                          value="Next"
                        />
                      ) : null}
                      {/* jhkj */}
                      {this.state.userExist ? (
                        <input
                          type="button"
                          className="register-btn text-uppercase"
                          value="Proceed"
                          onClick={this.handleProceed}
                        />
                      ) : null}
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Register;
